var React = require('react');

function LandingTextcat (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 17h1v1h-1zm1-1h1v1h-1zm-1 0h1v1h-1zm2-1h1v1h-1zm-1 0h1v1h-1zm-1 0h1v1h-1z","fill":"#8b9bb5","key":0}),React.createElement("path",{"d":"M12 18v-3h3V5H5v13zm-5-5h3v1H7zm0-2h6v1H7zm0-2h6v1H7zm4-1H9V7h2zm0 6v-1h2v1z","fill":"#f6f6f6","key":1}),React.createElement("path",{"d":"M8 3V2H7V1H0v15h5V5h10v11h4V3z","fill":"#fbae37","key":2}),React.createElement("path",{"d":"M11 13h2v1h-2zm-4 0h3v1H7zm0-2h6v1H7zm0-2h6v1H7z","fill":"#8c9bb4","key":3}),React.createElement("path",{"d":"M11 2V1h-1V0H3v1h4v1h1v1h11v13h1v-4h1V7h1V2z","fill":"#d77643","key":4}),React.createElement("path",{"fill":"#e43b44","d":"M9 7h2v1H9z","key":5})]);
}

LandingTextcat.defaultProps = {"viewBox":"0 0 22 18"};

module.exports = LandingTextcat;

LandingTextcat.default = LandingTextcat;
